<template>
<div class="diapo-container" > 
<div class="overlay-buttons__container vjs-big-slide-diapo">
   <div class="overlay-buttons-content-slides" id="dark-overlay-buttons-slides" >
    <button v-show="!focusedPlayer " class="overlay-button" id="focus-slides-btn"
      @click="focusSlides" v-html="SVG.MAXIMIZE_SVG"></button>
    <button v-show="focusedPlayer " class="overlay-button" id="unfocus-slides-btn"
      @click="unfocusSlides" v-html="SVG.MINIMIZE_SVG"></button>

              <button v-show="!focusedPlayer" class="overlay-button" id="switch-btn-image" @click="changeVideoSlide"  v-html="SVG.SWITCH"></button>

  </div>
  </div>
 
        <img class="vjs-big-slide-diapo" id="slide-image" :src="currentSlide" alt="big-diapo"/>

     
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { SVG } from "@/components/utils/const";
import {updateOverlayButtonsPosition ,updateBigPlayButton ,changeVideoSlide} from "../../utils/richmedia.js"
import en from '../../../i18n/en_US';
import fr from '../../../i18n/fr_FR'
    let slideBg =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAQAAADa613fAAAACXBIWXMAAAsTAAALEwEAmpwYAAADGGlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjaY2BgnuDo4uTKJMDAUFBUUuQe5BgZERmlwH6egY2BmYGBgYGBITG5uMAxIMCHgYGBIS8/L5UBFTAyMHy7xsDIwMDAcFnX0cXJlYE0wJpcUFTCwMBwgIGBwSgltTiZgYHhCwMDQ3p5SUEJAwNjDAMDg0hSdkEJAwNjAQMDg0h2SJAzAwNjCwMDE09JakUJAwMDg3N+QWVRZnpGiYKhpaWlgmNKflKqQnBlcUlqbrGCZ15yflFBflFiSWoKAwMD1A4GBgYGXpf8EgX3xMw8BSMDVQYqg4jIKAUICxE+CDEESC4tKoMHJQODAIMCgwGDA0MAQyJDPcMChqMMbxjFGV0YSxlXMN5jEmMKYprAdIFZmDmSeSHzGxZLlg6WW6x6rK2s99gs2aaxfWMPZ9/NocTRxfGFM5HzApcj1xZuTe4FPFI8U3mFeCfxCfNN45fhXyygI7BD0FXwilCq0A/hXhEVkb2i4aJfxCaJG4lfkaiQlJM8JpUvLS19QqZMVl32llyfvIv8H4WtioVKekpvldeqFKiaqP5UO6jepRGqqaT5QeuA9iSdVF0rPUG9V/pHDBYY1hrFGNuayJsym740u2C+02KJ5QSrOutcmzjbQDtXe2sHY0cdJzVnJRcFV3k3BXdlD3VPXS8Tbxsfd99gvwT//ID6wIlBS4N3hVwMfRnOFCEXaRUVEV0RMzN2T9yDBLZE3aSw5IaUNak30zkyLDIzs+ZmX8xlz7PPryjYVPiuWLskq3RV2ZsK/cqSql01jLVedVPrHzbqNdU0n22VaytsP9op3VXUfbpXta+x/+5Em0mzJ/+dGj/t8AyNmf2zvs9JmHt6vvmCpYtEFrcu+bYsc/m9lSGrTq9xWbtvveWGbZtMNm/ZarJt+w6rnft3u+45uy9s/4ODOYd+Hmk/Jn58xUnrU+fOJJ/9dX7SRe1LR68kXv13fc5Nm1t379TfU75/4mHeY7En+59lvhB5efB1/lv5dxc+NH0y/fzq64Lv4T8Ffp360/rP8f9/AA0ADzT6lvFdAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAQUSURBVHja7JtdaBRXFMd/O0nxA4n1A00UDQaUvGgeWvrgB2oRpPQD2QYbS6gNaS2EPtkWYlUURFyhHw95kIKtJVSSFqFN6WNpGwX7oSBaTUKRWtFmI5ViEBUxdXxwcjMzdNeZe/dsuuWcl9xzd/bM/Ob87z33zk4yCxG2JzjETXZzUib81eBvtTQHn9EITGWV7Gky4hnxx88kmxGP/4kpiIIoyKNmLV8zoiAKUsQmliiZCiXwVVoKoiAKoiAKoiAKoiAKoiAKImL19DDMMD3UFz9w4uFD5j+JcZaZQXuUJi5X6sYqZzBgJrnKlda6iLdWEiSxhi2sgTk2Dx/cNNzCMwU0bGvP081jkZ5+uYyk0HAqq+IAfTwe6RulU27WylMb8q5FPHubT29odFylGp9+Ogvk23eXViNzI/5cVpbgl8I1fE5d0B5jB+9JF8RWTsVuQxXH2eUo1rf4zmDkeTophq20ptFFe4HPfqCVP60gajhCNhSnhWsJvuVQEBv5OYRxiRFGuBia+8/ygkXUFZw2GD4H2ZAIw0FarZxiedC+zas0UEcdS8nyd9A7hz66mJIq6lZ+YmnQvsEmOvkn3WWlk1ZUUhfYzEDo00UcZY3xztHCYKJrmEIXrxvvDM38noLAQlpRSR3hqQgGXGE9e82dXMFpXksQdQknQxiHWZkKwyIjrRxiRtC+RQfdBY5bzVEWG+8LtjFaJOpzdDMraN+hg09TE/jJQOrJsZYMt2kwfefZXFQ0szgcmn3+4GV+LFC/99FpznuRFzlnkYpEIOH9wLh9wpvceWT4N/iQaaas7SHH/dgR8+hlvfG+pK1o5hzHSC6GcYtXaE+AAR/xJL+ahel+vmVBTIBnDMYY75C1xEg4RoZNlX14wuUMpYg9lffpMN512vgmaG/noFkV5HmJEw4EfnqQkYiXzDbxMbON9xs1wD0Wpa7fjtLqjy0+0ttXNIWiLKOWWoPhk0tbv22llWTzn2T1sJM9VMV6b7CVr0tAkGr6pch+IJmtoj+Cco9Gu8JnC1I6G2G+43gr+erXzr53Hm8C+xGph20VkZHLNNFLnjy9JX7eUuaMSJm+i6IgCqIgCqIgCqIgCqIgClKpVh1f12tGFERBYmNEeq+u/xmqY0TEmv+lVYEgzfSYdo8siieMUR2aVkRRvDJhiKN4ZcMQRvGEMcZM35gsiieMscX0bpFF8YQxjpn+Y7IoXpkwxFG8smEIo3hlxBBF8cQxHr53OiSNUlUjnY0hlnCddvKmZ4BBsniAR5bB2OtrKW37+C5hYblE5fqNMuxHbC6q5ALzJgVDAMWbJIySo7iBbHRUehTl2ckDedd5wIZRPpg8kOklmHcmUJxeQXOrIxdYxl3a6HO6HQP8wmL+4m2u2NeRBwMAfLg9I70bN1kAAAAASUVORK5CYII=';

export default defineComponent({
  name: "rm-slides",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
 
  props: ["slides", "player"],
  data: () => ({
    currentSlide: slideBg,
    previousSlide: 0,
    currentTime: 0,
   focusedPlayer: false,
   SVG:SVG,
   changeVideoSlide:changeVideoSlide

  
  }),
methods: {
    focusSlides() {
         const Parent = document.getElementById(
        "vjs_video_3"
      );
         const videoElementWrapper = document.getElementById(
        "rm-slides")
     
    if(videoElementWrapper && Parent){
   Parent.classList.add('vjs-popout');
 videoElementWrapper.classList.add('focused');
          this.focusedPlayer=true
     
    }
   
         

  
  updateOverlayButtonsPosition();

    },
      
    unfocusSlides() {
       const videoElementWrapper = document.getElementById(
        "rm-slides")
            const drag = document.querySelector(".drag");

    if(videoElementWrapper){
  videoElementWrapper.classList.remove('focused');
          this.focusedPlayer=false
          drag.classList.remove("vjs-hidden")

    }
  

  
  updateOverlayButtonsPosition();
  updateBigPlayButton();
    },
},
  mounted() {
    
    if (this.slides && this.slides.length) {


      const rmContent = document.getElementById("rm-slides");
      const thumbnails = document.getElementById("vjs-sliders-content");
        const overkayButtons = document.getElementById("dark-overlay-buttons");
      const mainVideoContainer = document.getElementById("vjs_video_3");
      const videoElement = document.querySelector(".vjs-tech");
      videoElement?.classList.add("video-slides");
      mainVideoContainer?.classList.add("vjs-slides");
      
      rmContent && mainVideoContainer?.appendChild(rmContent);
      thumbnails && mainVideoContainer?.appendChild(thumbnails);
      overkayButtons&& mainVideoContainer?.appendChild(overkayButtons);
      const svgTitle = document.querySelector('.carousel__icon title')
      if (svgTitle) {
        svgTitle.remove()
      }
      const NextsvgTitle = document.querySelector('.carousel__next svg title')
      if (NextsvgTitle) {
        NextsvgTitle.remove()
      }
      if (this.disabledPrevBtn) {
        this.disabledPrevBtn.title = this.$t('interactivity.prevSlide');
      }
      if (this.nextBtn) {
        this.nextBtn.title = this.$t('interactivity.nextSlide');
      }
      if (this.prevBtn) {
        this.prevBtn.title = this.$t('interactivity.prevSlide');
      }
    }
  },
  watch: {
    player: {
      handler() {
        this.player.on("timeupdate", () => {
          this.slides?.forEach((slide) => {
            if (slide.timecode <= this.player.currentTime()) {
              this.currentSlide = slide.src;
            }
          });
        });
      },
      deep: true
    },
  
  },


});
</script>
<style>

#vjs_video_3.vjs-slides {
  background-image: linear-gradient(180deg,var(--vm-color-three-06),var(--vm-color-two-04) 100%);
  display: flex;
}


.video-js.vjs-has-started.vjs-slides .vjs-tech.video-slides .overlay-btn {
  cursor: pointer;
    background-color: rgba(0, 0, 0, .8);
    padding: .5em;
    margin-left: .2em;
    border-radius: .25rem;
    font-size: 1.2em !important;
}
.video-js.vjs-has-started.vjs-slides.vjs-playing:not(.vjs-user-active) .vjs-tech.video-slides {
      height: calc(80% - 0.5em);

}
.video-js.vjs-has-started.vjs-slides .vjs-tech.video-slides {
    height: calc(80% - 3.5em);
    width: 50%;
    position: absolute;
    right: 0;
    margin: 0;
    padding: 0;
    font-size: 11px;
    transition: height .5s ease;
}

.video-js.vjs-slides.vjs-playing:not(.vjs-user-active) #rm-slides {
       height: calc(80% - 0.5em);

}
#rm-slides {
     height: calc(80% - 3.5em);
    width: 50%;
    position: absolute;
    right: 0;
    margin: 0;
    padding: 0;
    font-size: 11px;
    transition: height .5s ease;
    display: none;
}

.video-js.vjs-has-started #rm-slides {
  display: block;
  pointer-events: auto;
}



.video-js.vjs-has-started.vjs-slides .vjs-big-play-button {
  left: 25%;
}

.video-js.vjs-has-started.vjs-slides .vjs-rewind-button {
  display: block;
  left: 10% !important;
}

.video-js.vjs-has-started.vjs-slides .vjs-forward-button {
  display: block;
  left: 40% !important;
}



.video-js.vjs-has-started.vjs-slides .vjs-text-track-display>div>div {
  width: 50% !important;
}

.slides-divider {
  border: 1px solid var(--vm-color-three-02);
  width: 1px;
  margin: auto;
  height: 100%;
}





#gallery {
  height: 66%;
display: flex !important;
  justify-content: center !important;
  align-items: center !important;}

.carousel__viewport,
.carousel__track {
  height: 100%;
}





#gallery img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}





.carousel__prev svg,
.carousel__next svg {
  width: 2em;
  height: 2em;
}

.carousel__prev {
  left: -3%;
}

.carousel__next {
  right: -3%;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 2px solid var(--vm-color-one-06) !important;
  border-radius: 50%;
  background: var(--vm-color-one-08) !important;
}

.carousel__slide {
  padding: 5px;
}

@media only screen and (max-height: 250px) {
  #vjs_video_3.vjs-slides #rm-slides #gallery {
    display: none !important;
  }
}

@media only screen and (max-width: 768px)  and (orientation: portrait) {
  .video-js.vjs-has-started.vjs-slides .vjs-tech.video-slides {
    width: 100%;
    height: 40% !important;
    min-height: 40% !important;
    transform: inherit;
    top: 0;
  }

  .video-player-playlist {
    height: 100% !important;
  }

  .playlist-container {
    height: 25% !important;
  }

  .video-js.vjs-has-started.vjs-slides .vjs-big-play-button {
    left: 50%;
    top: 20%;
  }

  .video-js.vjs-has-started.vjs-slides .vjs-rewind-button {
    left: 20% !important;
    top: 20% !important;
  }

  .video-js.vjs-has-started.vjs-slides .vjs-forward-button {
    left: 80% !important;
    top: 20% !important;
  }

#vjs_video_3.vjs-slides #vjs-sliders-content{
  height: 15%;
  bottom: 5%;
}

  #vjs_video_3.vjs-slides #rm-slides {
    position: absolute;
    top: 40%;
    width: 100%;
  }
.vjs-big-slide-diapo {
    display: block;
    position: absolute;
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    top: 50%;
    left: 50%;
    margin: 0 15px;
}


  #vjs_video_3.vjs-slides #rm-slides #gallery {
    display: flex;
    height: 30vh;
  }

  #vjs_video_3.vjs-slides #rm-slides  {
    margin: auto;
    padding: 0;
    width: 75%;
  }


  #vjs_video_3.vjs-slides #rm-slides  .timecode {
    font-size: 2.25vw;
    bottom: 0%;
    padding: 1px;
  }

  .video-js.vjs-slides.vjs-has-started .vjs-text-track-display>div>div {
    width: 100% !important;
    top: 60% !important;
  }


}

@media only screen and (max-height: 450px) {
  #vjs_video_3.vjs-slides #rm-slides #gallery {
    display: flex;
  }

  #vjs_video_3.vjs-slides #rm-slides .slides-container {
    margin: auto !important;
    max-height: 33vw !important;
  }
}

@media only screen and (max-height: 680px) {
  #vjs_video_3.vjs-slides #rm-slides .slides-container {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  #vjs_video_3.vjs-slides #rm-slides .slides-container  {
    padding: 0;
  }

}
</style>